import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, n: number, addElispe: boolean = false): string {
    let truncVal: string;
    if (value.length <= n) truncVal = value;
    else {
      truncVal = value.substring(0, n);
      if (addElispe) truncVal += '...';
    }
    return truncVal;
  }
}
